import React from 'react';
import { HeatTd, HeatSwatch } from './Accountability.style';

interface HeatCellProps {
  count: number;
  level: number;
  label: string;
  thin?: boolean;
  /** Column index within the bucket strip; exposed as `data-col` so a single
   * delegated hover handler on the table can identify which column a
   * pointer event landed in without a per-cell closure. */
  colIndex: number;
  /** True when this cell's column is the one currently hovered. */
  highlighted?: boolean;
}

/**
 * One heatmap cell. The number is always rendered, so colour is never the
 * only channel carrying meaning, and the aria-label spells the cell out for
 * screen readers.
 *
 * Wrapped in React.memo: the grid can be ~1,000 rows x ~41 columns, and every
 * prop here is a primitive (number/string/boolean), so the default shallow
 * comparison is effective -- a column-hover change only re-renders the cells
 * whose `highlighted` value actually flipped, not the whole grid.
 */
const HeatCell: React.FC<HeatCellProps> = React.memo(
  ({ count, level, label, thin, colIndex, highlighted }) => (
    <HeatTd
      data-col={colIndex}
      data-highlighted={highlighted ? 'true' : 'false'}
      highlighted={highlighted}
    >
      <HeatSwatch level={level} thin={thin} aria-label={label} title={label} role="img">
        {count}
      </HeatSwatch>
    </HeatTd>
  ),
);

HeatCell.displayName = 'HeatCell';

export default HeatCell;
